import cx from "classnames";
import { type PropsWithChildren } from "react";

import { Heading, Icon, Span } from "@icg360/design-system";

import { type Address, formatAddress } from "utils";

import styles from "./policy-summary.module.scss";

type PolicySummaryProps = PropsWithChildren<{
  address?: Address | null;
  policyId: string;
  isCommercial: boolean;
  className?: string;
}>;

export const PolicySummary = ({
  address,
  policyId,
  isCommercial,
  className,
  children,
}: PolicySummaryProps) => (
  <div className={cx(styles.policyItemHeader, className)}>
    <div className={styles.policyIcon}>
      <Icon name={isCommercial ? "Store" : "House"} size="lg" />
    </div>
    <div className={styles.content}>
      <Heading size="sm">{formatAddress(address, true)}</Heading>
      <Span>
        <Span bold>Policy number:</Span> {policyId}
      </Span>
      {children}
    </div>
  </div>
);
